/* eslint-disable
    eqeqeq,
    @typescript-eslint/no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { isEmbeddedInAtlassian } from '@trello/browser';
import { assert } from '@trello/error-handling';

import { Auth } from 'app/scripts/db/Auth';
import { View } from 'app/scripts/views/internal/view';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { MemberTemplate } from 'app/scripts/views/templates/MemberTemplate';
import {
  LazyBoardProfileCard,
  LazyProfileCard,
} from 'app/src/components/ProfileCard';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

class MemberOnBoardView extends View {
  static initClass() {
    this.prototype.tagName = 'a';
    this.prototype.className = 'member js-member';
    this.prototype.viewTitleKey = 'change permissions';

    this.prototype.attributes = { tabindex: 0 };

    this.prototype.zIndex = 0;

    this.prototype.events = {
      click: 'showMenu',
      keydown: 'showMenu',
    };
  }

  initialize({ board, notClickable, small, hideBadges, zIndex, testId }) {
    this.board = board;
    this.workspace = board.getOrganization();
    this.notClickable = notClickable;
    this.small = small;
    this.hideBadges = hideBadges;
    this.zIndex = zIndex;
    this.testId = testId;

    assert(
      this.model != null,
      'You cannot have a deleted member as a board member!',
    );
    this.listenTo(this.model, 'change', this.render);
    this.listenTo(this.board, 'change:memberships', this.render);
    if (this.workspace) {
      this.listenTo(this.workspace, 'change:memberships', this.render);
    }
  }

  render() {
    const data = this.model.toJSON();

    const isAdmin = (parent) => {
      const membership = parent?.getMembershipFor(this.model);
      return membership?.memberType === 'admin';
    };

    // if the person is a paid workspace admin, then they are board admin, too, dang it
    const workspace = this.board.getOrganization();
    data.isBoardAdmin =
      isAdmin(this.board) ||
      (isAdmin(workspace) && this.board.isFeatureEnabled('superAdmins'));

    data.isGhost = this.model.get('memberType') === 'ghost';
    data.isDeactivated = this.board.isDeactivated(this.model);
    data.hideBadges = this.hideBadges;

    this.$el.html(MemberTemplate(data)).css('z-index', this.zIndex);

    this.$el.attr('data-testid', this.testId);

    if (this.small) {
      this.$el.addClass('m-member-mod-24');
    }
    if (this.notClickable) {
      this.$el.addClass('m-member-mod-no-click');
    }

    this.$el.toggleClass(
      'member-deactivated js-member-deactivated',
      data.isDeactivated,
    );
    this.$el.toggleClass(
      'member-virtual-invitee',
      data.memberType === 'ghost' &&
        (data.idMemberReferrer == null ||
          data.idMemberReferrer === Auth.me().id),
    );

    this.$el.toggleClass(
      'long-initials',
      (data.initials != null ? data.initials.length : undefined) > 2,
    );

    if (data.isGhost) {
      this.$el.addClass('member-virtual');
    }

    this.$el.data('id', this.model.id);
    return this;
  }

  showMenu(e) {
    if (DragSort.sorting || this.notClickable) {
      return;
    }

    if (e.type === 'keydown') {
      e?.stopPropagation();
      if (e.key !== ' ' && e.key !== 'Enter') {
        return;
      }
    } else {
      stopPropagationAndPreventDefault(e);
    }

    const popoverMethod = this.options.pushView ? 'pushView' : 'toggle';
    PopOver[popoverMethod]({
      elem: e.currentTarget,
      reactElement: isEmbeddedInAtlassian() ? (
        <LazyProfileCard
          key="profile-embedded"
          memberId={this.model.id}
          // eslint-disable-next-line react/jsx-no-bind
          onClose={() => PopOver.hide()}
          // eslint-disable-next-line react/jsx-no-bind
          onBack={this.options.pushView ? () => PopOver.popView() : undefined}
        />
      ) : (
        <LazyBoardProfileCard
          key="profile"
          // eslint-disable-next-line react/jsx-no-bind
          onClose={() => PopOver.hide()}
          memberId={this.model.id}
          boardId={this.board.id}
          // eslint-disable-next-line react/jsx-no-bind
          onBack={this.options.pushView ? () => PopOver.popView() : undefined}
        />
      ),
      hideHeader: true,
    });
  }
}

MemberOnBoardView.initClass();
export { MemberOnBoardView };
